import { ChevronDown, ChevronRight } from "lucide-react";
import React, { useState } from "react";
interface propsType {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
const ContactSection = ({ title, icon, children, defaultOpen = false }: propsType) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border border-slate-200 dark:border-zink-500 rounded-lg  dark:bg-zink-700 shadow-sm">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between w-full p-4 text-base font-semibold text-slate-800 dark:text-zink-100 hover:bg-slate-50 dark:hover:bg-zink-600 transition-colors duration-200 rounded-lg"
      >
        <div className="flex items-center gap-3">
          {icon}
          <span>{title}</span>
        </div>
        {open ? (
          <ChevronDown className="w-4 h-4 text-slate-500" />
        ) : (
          <ChevronRight className="w-4 h-4 text-slate-500" />
        )}
      </button>
      {open && <div className="px-4 pb-4 space-y-4">{children}</div>}
    </div>
  );
};

export default ContactSection;
